'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = createKMapMiddleware;

var _actions = require('../actions');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @desc kmapMiddleware is used to catch actions that require interaction with the kmap instance
 */


function createKMapMiddleware() {
  var kmapInstance = void 0;

  var kmapMiddleware = function kmapMiddleware(store) {
    return function (next) {
      return function (action) {
        var callAPI = action[_actions.KMAP_API];
        var getState = store.getState; // if the action does not have a KMAP_API propery, just pass it to the next middleware

        if (typeof callAPI === 'undefined') {
          return next(action);
        }
        /**
         * if the action does have a KMAP_API property, and it is a a function (action creator),
         * and we have a map instance then call it with the map instance and current state,
         * and pass the result (action) to the next middleWare
         */


        if (typeof callAPI === 'function' && kmapInstance) {
          var response = callAPI(kmapInstance, getState);

          if (response instanceof _promise2.default) {
            return response;
          }

          return next(response);
        } // if the action has a KMAP_API property, and it is not a function, then it is an action object
        // so we check the type and act accordingly...


        switch (callAPI.type) {
          case _actions.INITIALIZE_KMAP_SUCCESS:
            // set instance
            kmapInstance = action.kmap;
            return next(callAPI);

          default:
        } // after we've processed the action we pass to next middleware


        return null; // next(action);
      };
    };
  };

  return kmapMiddleware;
}
/**
 * General flow is...
 * - kmap actions caught by middleware (because KMAP_API)
 * - map instance is injected and function executed
 * - returns plain action object that gets next'd to the remaning middleware
 */